export default __webpack_public_path__ + "static/media/icon-Code.c7525069.svg";